/**
 * Marcação de início de requisição, para o erro carregar `http_duration_ms`.
 *
 * Vive aqui e não na camada de serviço porque `shared/helpers` já depende deste
 * módulo; o contrário criaria ciclo. Tipagem frouxa de propósito: folha do grafo
 * não importa axios.
 */
export const REQUEST_STARTED_AT_KEY = 'observabilityRequestStartedAt';

/** Monotônico: `Date.now()` pode andar para trás com ajuste de NTP. */
function monotonicNow(): number {
  return typeof performance !== 'undefined' &&
    typeof performance.now === 'function'
    ? performance.now()
    : Date.now();
}

type TimedConfig = {
  metadata?: Record<string, unknown>;
};

export function stampRequestStart<T>(config: T): T {
  try {
    const timed = config as T & TimedConfig;
    timed.metadata = {
      ...timed.metadata,
      [REQUEST_STARTED_AT_KEY]: monotonicNow(),
    };
  } catch {
    // Config congelado: segue sem duração.
  }
  return config;
}

export function readRequestDuration(config: unknown): number | undefined {
  if (typeof config !== 'object' || config === null) return undefined;

  const metadata = (config as TimedConfig).metadata;
  const startedAt = metadata?.[REQUEST_STARTED_AT_KEY];

  if (typeof startedAt !== 'number') return undefined;

  const elapsed = monotonicNow() - startedAt;
  return elapsed >= 0 ? Math.round(elapsed) : undefined;
}
